import { Button } from "@mui/material";

function EspecialidadeCard(props) {
    return (
        <div className="espeCardContainer">
            <div className="espeCardContent">
                <img src={props.img} className="espeCardImg"/>
                <div className="espeCardTitle">{props.title}</div>
                <div className="espeCardText">{props.text}</div>
            </div>
            
            <Button sx={{fontFamily:'Inter', margin:'15px',height:50, width:250, borderRadius:'5px', color:'#fff', fontSize:'15px', fontWeight:'bold', textTransform: 'none', backgroundColor:'#B08E44','&:hover': {color: '#B08E44', backgroundColor:'#fff'}}} onClick={props.onClick}>Ver mais</Button>
        </div>
    )
}
export default EspecialidadeCard;